import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    "&.Mui-checked": {
        color: "var(--primary-color)",
        "&:hover": {
            backgroundColor: "rgba(0,111,143,0.1)",
        },
    },
    "&:hover": {
        backgroundColor: "rgba(0,111,143,0.1)",
    },
}));

const Check = ({
    label,
    onClick,
    value,
    primary,
    labelStyle,
    checked,
    checkBoxStyle,
}) => {
    return (
        <FormControlLabel
            label={label}
            className={primary ? "text-dark-grey" : "text-tertiary"}
            style={labelStyle}
            control={
                <StyledCheckbox
                    value={value}
                    checked={checked}
                    onClick={onClick}
                    style={checkBoxStyle}
                />
            }
        />
    );
};

export default Check;
